import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../components/fields/simpleField.jsx";
import { useInternet } from "../../hooks/useInternet.js";
import { useNotify } from "../../hooks/useNotify.js";
import { SubmitButton } from "../../components/fields/submitButton.jsx";
import { useState } from "react";

export function ResetPage() {
  let navigate = useNavigate();

  let [search, setSearch] = useSearchParams();
  let [isSubmitted, setIsSubmitted] = useState(false);
  let { control, handleSubmit, formState, reset } = useForm({
    resolver: zodResolver(
      zod.object({
        email: zod.string(),
      })
    ),
  });
  let internet = useInternet();
  let notify = useNotify();
  let login = (data) => {
    return internet
      .post("/auth/reset", { ...data })
      .then(async (res) => {
        reset({}, { keepValues: true });
        setIsSubmitted(true);
      })
      .catch(() => {
        notify({
          message: "unable to reset password",
          type: "danger",
        });
      });
  };
  return (
    <>
      <div className={"flex items-center"}>
        <h1 className={"font-bold display text-xl flex-grow"}>
          Reset my password
        </h1>
        <Link
          to={"/auth/login?" + search.toString()}
          className={"hover:underline"}
        >
          Log in instead
        </Link>
      </div>

      <p>
        Already having an account? Please indicate your login information below.
      </p>
      {search.get("invitation") && (
        <div className={"bg-orange-200 rounded p-3"}>
          You have been invited to join a team in Lancerkit. Filling the form
          below will make you join your team. If you don't want to do this,
          <a
            href={"#"}
            onClick={(e) => {
              e.preventDefault();
              setSearch("invitation", "");
            }}
            className={"underline"}
          >
            click here
          </a>
        </div>
      )}

      {isSubmitted ? (
        <div className={"p-3 bg-green-50 rounded"}>
          We have received your reset password request. You should receive soon
          an email with the reset instructions.
        </div>
      ) : (
        <form onSubmit={handleSubmit(login)} className={"flex flex-col gap-3"}>
          <SimpleField
            name={"email"}
            label={"email"}
            type={"email"}
            control={control}
          />
          <SubmitButton formState={formState}>Reset my password</SubmitButton>
        </form>
      )}
    </>
  );
}
